module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-item', {
      key: item.meta.listKey,
      attrs: {
        "title": item.meta.listHover
      },
      on: {
        "click": function($event) {
          return _vm.$emit('click', item)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v(_vm._s(item.meta.listIcon || 'folder'))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.meta.listTitle))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.meta.listDetails))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06703c46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/GenericList.vue
// module id = 2435
// module chunks = 1